import { PopUpComponent } from '../../../components/PopUpComponent';
import { InputComponent } from '../../../components/InputComponent';
import { IInventoryProvider } from '../../../interfaces/service/InventoryServiceManagerInterface';
import { ActivePopUp } from '../../../interfaces/interfaceInventory';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { CheckboxComponent } from '../../../components/CheckboxComponent';
import { ChangeEvent } from 'react';

interface ICaptureLimitComunicationModal {
  serviceInventory: IInventoryProvider;
}

export const CaptureLimitComunicationModal = (
  props: ICaptureLimitComunicationModal
) => {
  const { serviceInventory } = props;

  const bodyContent = () => {
    return (
      <div>
        {serviceInventory.triggerHeaderBody !== '' ? (
          <span> Configuración {serviceInventory.triggerHeaderBody}.</span>
        ) : (
          ''
        )}
        <div className="my-1">
          <div className="flex items-center justify-start text-center space-x-4">
            <div className="flex w-1/4">
              <CheckboxComponent
                checked={serviceInventory.isTimeChecked}
                onChange={() => serviceInventory.onTimeCheckboxChange()}
              />
              <span className="mx-1">Iniciar vía tiempo</span>
            </div>
            <span className="w-1/4">Al pasar</span>
            <div className="w-1/4">
              <InputComponent
                name="cuantity"
                type="number"
                value={serviceInventory.timeValue.toString()}
                disabled={!serviceInventory.isTimeChecked}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  serviceInventory.handleInputTimeChange(e.target.value)
                }
              />
            </div>
            <span className="w-1/4">minutos.</span>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-start text-center space-x-4">
            <div className="flex w-1/4">
              <CheckboxComponent
                checked={serviceInventory.isQuantityChecked}
                onChange={() => serviceInventory.onQuantityCheckboxChange()}
              />
              <span className="mx-1">Iniciar vía cantidad</span>
            </div>
            <span className="w-1/4">Cuando queden</span>
            <div className="w-1/4">
              <InputComponent
                name="cuantity"
                type="number"
                value={serviceInventory.quantityValue.toString()}
                disabled={!serviceInventory.isQuantityChecked}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  serviceInventory.handleInputQuantityChange(e.target.value)
                }
              />
            </div>
            <span className="w-1/4">transacciones.</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <PopUpComponent
      header={serviceInventory.popUpHeader}
      showPopUp={
        serviceInventory.activePopUp === ActivePopUp.CaptureLimitComunication &&
        serviceInventory.showPopUp
      }
      onSubmit={() => serviceInventory.handleSubmitComunicationTriggers()}
      onClosePopUp={() => serviceInventory.closePopUp()}
      footerOnlyCancel={false}
      footer={true}
      body={bodyContent()}
    />
  );
};
